import { CampaignTextField } from "../../../react4xp/parts/campaign-page-text-field/campaign-page-text-field";

export default (props) => <CampaignTextField {...props} />